@if (detailData?.id) {
  @if (isAdmin || isDispatchUser) {
    <div class="d-flex gap-2 mb-2">
      <button class="btn btn-outline-primary btn-sm" (click)="openCamPopup()">
        + Attach Photo
      </button>

      <button
        class="btn btn-sm"
        [ngClass]="incidentComplete ? 'btn-outline-success' : 'btn-success'"
        (click)="sendReport(reportConfirmationTemplate)"
      >
        Send Report
      </button>

      @if (!incidentComplete) {
        <button
          class="btn btn-sm btn-outline-success"
          (click)="markIncidentComplete()"
        >
          Mark Complete
        </button>
      }
    </div>
  }
}
@if (detailData?.company?.is_subcontracting) {
  <div
    class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
  >
    {{ detailData?.company?.company_name }} is a Prime Contractor
  </div>
}

<div class="p-lg-5 p-2 report-preview shadow bg-white text-black">
  @if (isAdmin || isDispatchUser) {
    <div
      class="d-flex gap-3 gap-lg-5 border border-1 rounded mb-2 py-2 px-1 showHideControls flex-wrap"
    >
      <div class="fw-semibold small">Show/Hide</div>
      <div>
        <div
          (click)="
            updateIncidentDetails(
              {
                incident_id: detailData?.id,
                hide_header: !detailData?.additional_info?.hide_header,
              },
              {},
              false
            )
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_header
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Header
        </div>
      </div>
      @if (!detailData?.additional_info?.hide_header) {
        <div>
          <div
            (click)="
              updateIncidentDetails(
                {
                  incident_id: detailData?.id,
                  hide_subscriber_header_details:
                    !detailData?.additional_info
                      ?.hide_subscriber_header_details,
                },
                {},
                false
              )
            "
            role="button"
            [ngClass]="
              detailData?.additional_info?.hide_subscriber_header_details
                ? 'opacity-50'
                : 'text-primary'
            "
            class="small"
          >
            Company Address
          </div>
        </div>
      }

      @if (
        !detailData?.company?.is_subcontracting &&
        (detailData?.company?.custom_address ||
          detailData?.company?.report_address)
      ) {
        <div>
          <div
            (click)="
              updateIncidentDetails(
                {
                  incident_id: detailData?.id,
                  hide_client_detail:
                    !detailData?.additional_info?.hide_client_detail,
                },
                {},
                false
              )
            "
            role="button"
            [ngClass]="
              detailData?.additional_info?.hide_client_detail
                ? 'opacity-50'
                : 'text-primary'
            "
            class="small"
          >
            Client Address
          </div>
        </div>
      }
      <div>
        <div
          (click)="
            updateIncidentDetails(
              {
                incident_id: detailData?.id,
                hide_incident_created_guard_name:
                  !detailData?.additional_info
                    ?.hide_incident_created_guard_name,
              },
              {},
              false
            )
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_incident_created_guard_name
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Guard Name
        </div>
      </div>
    </div>
  }

  @if (detailData?.id) {
    @if (!detailData?.additional_info?.hide_header) {
      <div class="header-container">
        <div class="subscriber_company_information_section">
          @if (!detailData?.additional_info?.hide_subscriber_header_details) {
            <div class="strong">
              {{ subscriberInfo?.name }}
            </div>
            <div>{{ subscriberInfo?.address }}</div>
            <div>{{ subscriberInfo?.city }}</div>
            @if (subscriberInfo?.mobile_number) {
              <div>Ph: {{ subscriberInfo?.mobile_number }}</div>
            }
            <div>{{ subscriberInfo?.email }}</div>
          }
        </div>
        <div class="text-center">
          @if (subscriberInfo?.logo_url) {
            <img
              [ngClass]="largeView ? 'logo_img_large' : 'logo_img_mob'"
              alt="placeholder_logo"
              src="{{ subscriberInfo?.logo_url }}"
            />
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
            >
              Update Logo
            </div>
          } @else {
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
            >
              Upload Logo
            </div>
          }
        </div>
      </div>
    }
    <div class="report-type-heading">Incident Report</div>
    <!--CLIENT INFORMATION SECTION-->
    @if (!detailData?.company?.is_subcontracting) {
      <div class="client_information_section">
        <div>{{ detailData?.company?.company_name }}</div>
        @if (!detailData?.additional_info?.hide_client_detail) {
          @if (detailData?.company?.custom_address) {
            <div class="gt-multi-line">
              {{ detailData?.company?.custom_address }}
            </div>
          }
          <div>
            {{ detailData?.company?.report_address?.address }}
          </div>
          <div>
            {{ detailData?.company?.report_address?.city }}
          </div>
        }
      </div>
    }
    <div class="patrol-table mt-5">
      @if (timeZoneData?.time_zone && timeZoneData?.time_zone_diff) {
        <div
          style="
            font-size: 10px;
            padding-bottom: 0.5rem;
            color: #333;
            font-weight: bold;
            font-style: italic;
          "
        >
          Timestamps shown in
          {{ timeZoneData?.time_zone }}
          {{ timeZoneData?.time_zone_diff }}
        </div>
      }
      <table style="width: 100%; max-width: 100%" class="responsive">
        <tr>
          <td class="cell-heading">Date</td>
          <td>
            {{
              (detailData?.additional_info?.report_date
                ? detailData?.additional_info?.report_date
                : today
              ) | date: "dd MMM yyyy" : timeZoneOffset
            }}
            @if (isAdmin || isDispatchUser) {
              <span
                class="ms-1 edit-button"
                (click)="openReportDateTemplate(reportDateTemplateRef)"
              >
                <span id="edit-button-placeholder d-none"></span>
              </span>
            }
          </td>
          <td class="cell-heading">Reference No.</td>
          <td>{{ detailData?.incident_key }}</td>
        </tr>
        <tr>
          <td class="cell-heading">Incident Type</td>
          <td colspan="3">
            @if (detailData?.incident_types?.length) {
              @for (
                iType of
                  detailData?.incident_types;
                track $index;
                let first = $first, last =
                  $last
              ) {
                {{ iType?.name }}{{ last ? "" : ", " }}
              }
            } @else {
              {{ detailData?.incident_type }}
            }
            @if (isAdmin || isDispatchUser) {
              <span
                class="ms-1 edit-button"
                (click)="
                  openupdateIncidentTypeTemplate(incidentTypeTemplateRef)
                "
              >
                <span id="edit-button-placeholder d-none"></span>
              </span>
            }
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Incident Time</td>
          <td colspan="3">
            {{
              detailData?.incident_time
                | date: "dd MMM yyyy HH:mm" : timeZoneOffset
            }}
            @if (isAdmin || isDispatchUser) {
              <span
                class="ms-1 edit-button"
                (click)="editTimeStamp('iTime', incidentTimeTemplateRef)"
              >
                <span id="edit-button-placeholder d-none"></span>
              </span>
            }
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Resolution Time</td>
          <td colspan="3">
            {{
              detailData?.resolution_time
                | date: "dd MMM yyyy HH:mm" : timeZoneOffset
            }}
            @if (isAdmin || isDispatchUser) {
              <span
                class="ms-1 edit-button"
                (click)="editTimeStamp('rTime', incidentTimeTemplateRef)"
              >
                <span id="edit-button-placeholder d-none"></span>
              </span>
            }
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Location</td>
          <td colspan="3">
            <span class="fw-semibold">{{
              detailData?.site?.company_name
            }}</span>
            &emsp;
            {{ detailData?.site?.address?.full_address }}
          </td>
        </tr>
        @if (!detailData?.additional_info?.hide_incident_created_guard_name) {
          <tr>
            <td class="cell-heading line-height">Reported By</td>
            <td colspan="3">
              <div class="d-flex">
                <div class="pe-2">
                  <div class="gt-multi-line line-height fs-6">
                    {{ detailData?.subscriber_user?.full_name }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        }
        <tr>
          <td class="cell-heading line-height">Details</td>
          <td colspan="3">
            <div class="d-flex">
              <div class="pe-2">
                <div class="gt-multi-line line-height fs-6">
                  {{ detailData?.information }}
                </div>
              </div>
              <div>
                @if (isAdmin || isDispatchUser) {
                  <span
                    (click)="openExtraInfoTemplate(extraInfoTemplateRef, 'an')"
                    class="edit-button"
                  >
                    <span id="edit-button-placeholder d-none"></span
                  ></span>
                }
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="cell-heading line-height">Resolution</td>
          <td colspan="3">
            <div class="d-flex">
              <div class="pe-2">
                <div class="gt-multi-line line-height fs-6">
                  {{ detailData?.corrective_actions }}
                </div>
              </div>
              <div>
                @if (isAdmin || isDispatchUser) {
                  <span
                    (click)="openExtraInfoTemplate(extraInfoTemplateRef, 'ca')"
                    class="edit-button"
                    ><span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    @if (incidentCommentFiles?.length) {
      <div class="report-summary-heading mb-2">
        <div class="d-flex mt-3 mb-1 align-items-center">
          <div>Incident Details</div>
        </div>
      </div>
      @if (isAdmin || isDispatchUser) {
        <div
          class="mb-3 border border-1 rounded p-1 d-flex gap-5 px-2 py-2 showHideControls"
        >
          <div class="fw-semibold small">Show/Hide</div>
          <div class="">
            <div
              (click)="
                updateIncidentDetails(
                  {
                    incident_id: detailData?.id,
                    hide_uploads: !detailData?.additional_info?.hide_uploads,
                  },
                  {},
                  false
                )
              "
              role="button"
              [ngClass]="
                detailData?.additional_info?.hide_uploads
                  ? 'opacity-50'
                  : 'text-primary'
              "
              class="small"
            >
              Photo Events
            </div>
          </div>
          @if (!detailData?.additional_info?.hide_uploads) {
            <div>
              <div
                (click)="
                  updateIncidentDetails(
                    {
                      incident_id: detailData?.id,
                      hide_guard_column:
                        !detailData?.additional_info?.hide_guard_column,
                    },
                    {},
                    false
                  )
                "
                role="button"
                [ngClass]="
                  detailData?.additional_info?.hide_guard_column
                    ? 'opacity-50'
                    : 'text-primary'
                "
                class="small"
              >
                Guard Names
              </div>
            </div>
          }
        </div>
      }
    }
    @if (sumamaryTableData?.length) {
      @if (largeView) {
        <div class="patrol-table">
          <table style="width: 100%; max-width: 100%">
            <thead>
              <tr>
                <th style="text-align: center">ID</th>
                <th>Time</th>
                <th>Event Type</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
                @if (isAdmin || isDispatchUser) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of sumamaryTableData; track row; let i = $index) {
                <tr
                  style="
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  "
                  id="section_up{{ i + 1 }}"
                >
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="text-align: center"
                    class="line-height"
                  >
                    {{ i + 1 }}
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="line-height"
                  >
                    {{
                      (row?.user_provided_timestamp
                        ? row?.user_provided_timestamp
                        : row?.updated_at
                      ) | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                    }}
                    @if (isAdmin || isDispatchUser) {
                      <span
                        (click)="
                          editEventTimeStamp(
                            row,
                            eventTimepStampUpdateTemplateRef
                          )
                        "
                        class="edit-button"
                        ><span id="edit-button-placeholder d-none"></span
                      ></span>
                    }
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="uppercase line-height"
                  >
                    <a
                      class="cursor-pointer"
                      (click)="
                        scrollToSection($event, 'section_down' + (i + 1))
                      "
                      style="color: #00538d"
                    >
                      {{
                        row?.event_action === 11
                          ? "Photo (Source: Device Library)"
                          : "Photo (Source: Camera)"
                      }}
                    </a>
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="border-left: hidden"
                  >
                    <div class="d-flex">
                      <div class="gt-multi-line line-height fs-6">
                        {{ row?.detail }}
                      </div>
                      @if (isAdmin || isDispatchUser) {
                        <div (click)="openCommentTemplate(commentRef, row)">
                          @if (row.detail) {
                            <span class="edit-button">
                              <span id="edit-button-placeholder d-none"></span>
                            </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row.user_name }}
                    </td>
                  }
                  @if (isAdmin || isDispatchUser) {
                    <td>
                      @if ([2, 11].includes(row?.event_action)) {
                        <div
                          class="ms-1"
                          (click)="
                            deleteRestoreUserUpdate({
                              event: row,
                              type: row?.is_deleted ? 'restore' : 'delete',
                            })
                          "
                        >
                          @if (row?.is_deleted) {
                            <span>
                              <i
                                class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                              ></i>
                            </span>
                          } @else {
                            <span>
                              <i
                                class="fs-5 fa-solid fa-circle-minus text-danger"
                              ></i>
                            </span>
                          }
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of sumamaryTableData; track row; let i = $index) {
              <tr id="section_up{{ i + 1 }}">
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div
                      class="line-height small text-secondary d-flex"
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    >
                      {{
                        (row?.user_provided_timestamp
                          ? row?.user_provided_timestamp
                          : row?.updated_at
                        ) | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                      }}
                      @if (isAdmin || isDispatchUser) {
                        <span
                          (click)="
                            editEventTimeStamp(
                              row,
                              eventTimepStampUpdateTemplateRef
                            )
                          "
                          class="ms-2 edit-button"
                          ><span id="edit-button-placeholder d-none"></span
                        ></span>
                      }
                    </div>
                    <div>
                      @if (
                        [2, 11].includes(row?.event_action) &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <div
                          class="ms-1"
                          (click)="
                            deleteRestoreUserUpdate({
                              event: row,
                              type: row?.is_deleted ? 'restore' : 'delete',
                            })
                          "
                        >
                          @if (row?.is_deleted) {
                            <span>
                              <i
                                class="fa-2x fa-solid fa-trash-can-arrow-up text-secondary"
                              ></i>
                            </span>
                          } @else {
                            <span>
                              <i
                                class="fs-5 fa-solid fa-circle-minus text-danger"
                              ></i>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between small text-secondary"
                  >
                    <div
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="uppercase line-height"
                    >
                      @if (row?.file) {
                        <a
                          class="cursor-pointer"
                          (click)="
                            scrollToSection($event, 'section_down' + (i + 1))
                          "
                          style="color: #00538d"
                        >
                          {{
                            row?.event_action === 11
                              ? "Photo (Source: Device Library)"
                              : "Photo (Source: Camera)"
                          }}
                        </a>
                      } @else {
                        {{
                          row?.event_action === 11
                            ? "Photo (Source: Device Library)"
                            : "Photo (Source: Camera)"
                        }}
                      }
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div
                        [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                        class="line-height"
                      >
                        {{ row.user_name }}
                      </div>
                    }
                  </div>
                  <div [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex pt-2">
                      <div class="gt-multi-line line-height fs-6">
                        {{ row.detail }}
                      </div>
                      @if (isAdmin || isDispatchUser) {
                        <div (click)="openCommentTemplate(commentRef, row)">
                          @if (row.detail) {
                            <span class="edit-button">
                              <span id="edit-button-placeholder d-none"></span>
                            </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    <!-- REPORT SUMMARY -->
    <!-- DETAILS SECTION -->
    <div
      class="mt-5"
      style="box-decoration-break: clone; -webkit-box-decoration-break: clone"
    >
      @for (item of incidentCommentFiles; track item; let i = $index) {
        @if (item?.file && !item?.is_deleted) {
          <div id="section_down{{ i + 1 }}">
            <div class="d-flex mb-2">
              <div
                [ngClass]="
                  largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                "
              >
                @if (item?.download_url) {
                  <a
                    href="{{ item.download_url }}"
                    style="text-decoration: none"
                  >
                    <button class="btn btn-primary btn-sm mb-3">
                      Download Video
                    </button>
                  </a>
                }
                <!--TIMESTAMP-->
                <div
                  style="font-weight: 600"
                  class="key-value d-flex gap-1 mb-3"
                >
                  {{
                    (item?.user_provided_timestamp
                      ? item?.user_provided_timestamp
                      : item?.updated_at
                    ) | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                  }}
                  @if (isAdmin || isDispatchUser) {
                    <span
                      (click)="
                        editEventTimeStamp(
                          item,
                          eventTimepStampUpdateTemplateRef
                        )
                      "
                      class="edit-button"
                      ><span id="edit-button-placeholder d-none"></span
                    ></span>
                  }
                  @if (
                    [2, 11].includes(item?.event_action) &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      class="ms-1"
                      (click)="
                        deleteRestoreUserUpdate({
                          event: item,
                          type: item?.is_deleted ? 'restore' : 'delete',
                        })
                      "
                    >
                      @if (item?.is_deleted) {
                        <span>
                          <i
                            class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                          ></i>
                        </span>
                      } @else {
                        <span>
                          <i
                            class="fs-5 fa-solid fa-circle-minus text-danger"
                          ></i>
                        </span>
                      }
                    </span>
                  }
                </div>
                <!-- GPS ACCURACY NOTIFICATION-->
                @if (item?.gps?.source) {
                  <div class="warning">
                    @if (item?.gps?.source == 1) {
                      Location Accuracy: Low
                    }
                    @if (item?.gps?.source == 2) {
                      Location Accuracy: Very Low
                    }
                  </div>
                }
                <!--SECTION: EVENT LOCATION-->
                @if (item?.gps?.lat && item?.gps?.lon) {
                  <div style="margin-bottom: 2rem">
                    <div class="key-label text-secondary">Event Location</div>
                    <div
                      style="max-width: 100%; height: 150px; object-fit: none"
                      class="small"
                    >
                      <gtapp-map-leaflet
                        [customMapConfig]="{ showSimpleStaticMap: true }"
                        [latLon]="{
                          markerTooltip: item?.event_by,
                          lat: item?.gps?.lat,
                          lon: item?.gps?.lon,
                        }"
                        [mapId]="'map_' + i"
                      ></gtapp-map-leaflet>
                    </div>
                  </div>
                }
                <!--SECTION:  PHOTO COMMENT/NOTES-->
                <div class="d-inline">
                  <div class="gt-multi-line">
                    @if (item?.detail) {
                      <span>
                        {{ item?.detail }}
                      </span>
                    }
                    @if (isAdmin || isDispatchUser) {
                      <span class="ms-auto">
                        @if (item?.detail) {
                          <span
                            (click)="openCommentTemplate(commentRef, item)"
                            class="edit-button"
                          >
                            <span id="edit-button-placeholder d-none"></span>
                          </span>
                          <span (click)="deleteComment(item)">
                            <i
                              class="fs-5 fa-solid fa-circle-minus text-danger"
                            ></i>
                          </span>
                        } @else {
                          <div
                            class="text-center pt-2"
                            (click)="openCommentTemplate(commentRef, item)"
                          >
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          </div>
                        }
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    item?.file_extension
                  )
                ) {
                  <video
                    controls
                    style="
                      max-height: 100%;
                      max-width: 100%;
                      display: flex;
                      width: 100%;
                    "
                  >
                    <source src="{{ item?.file }}" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    (click)="onOpenImage($event, item)"
                    src="{{ item?.file }}"
                    style="max-height: 100%; max-width: 100%; display: flex"
                  />
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
<!-- ADD COMMENT  DIALOG -->
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newValue = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newValue"
          id="updateCommentBox"
        ></textarea>
        @if (newValue) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newValue = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousTextValue === newValue"
              (click)="editComment(data); commentRef.close()"
              [ngClass]="newValue ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newValue || previousTextValue === newValue"
              (click)="editComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplate="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Recipients
      <span class="float-end" (click)="reportConfirmationTemplate.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (
      reportContactsData?.site_contacts?.length ||
      reportContactsData?.client_contacts?.length
    ) {
      <ul class="nav nav-tabs my-2" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="site-contacts-tab"
            data-bs-toggle="tab"
            data-bs-target="#site-contacts"
            type="button"
            role="tab"
            aria-controls="site-contacts"
            aria-selected="true"
          >
            Site Contacts
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="client-contacts-tab"
            data-bs-toggle="tab"
            data-bs-target="#client-contacts"
            type="button"
            role="tab"
            aria-controls="client-contacts"
            aria-selected="false"
          >
            Client Contacts
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="site-contacts"
          role="tabpanel"
          aria-labelledby="site-contacts-tab"
        >
          <div class="col-lg-6 mb-3">
            <button
              class="btn btn-sm btn-primary w-100"
              (click)="redirectToSite()"
            >
              {{
                reportContactsData?.site_contacts?.length
                  ? "Edit Recipients"
                  : "Add Recipients"
              }}
            </button>
          </div>
          @if (reportContactsData?.site_contacts?.length) {
            <ng-template
              *ngTemplateOutlet="
                contactRecipientSelectionTemplate;
                context: {
                  reportRecipientList: reportContactsData?.site_contacts,
                }
              "
            ></ng-template>
          }
        </div>
        <div
          class="tab-pane fade"
          id="client-contacts"
          role="tabpanel"
          aria-labelledby="client-contacts-tab"
        >
          <div class="col-lg-6 mb-3">
            <button
              class="btn btn-sm btn-primary w-100"
              (click)="redirectToSite('client')"
            >
              {{
                reportContactsData?.client_contacts?.length
                  ? "Edit Recipients"
                  : "Add Recipients"
              }}
            </button>
          </div>
          @if (reportContactsData?.client_contacts?.length) {
            <ng-template
              *ngTemplateOutlet="
                contactRecipientSelectionTemplate;
                context: {
                  reportRecipientList: reportContactsData?.client_contacts,
                }
              "
            ></ng-template>
          }
        </div>
      </div>
      @if (selectedReportRecipientSet.size) {
        <dt class="text-end me-4 pt-2">
          Total Recipients Selected:
          <span class="fw-semibold fs-6">{{
            selectedReportRecipientSet.size
          }}</span>
        </dt>
      }

      <div class="row row-cols-2 pt-4">
        <div class="col">
          <button
            class="btn btn-lg btn-secondary w-100"
            type="button"
            (click)="reportConfirmationTemplate.close(false)"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg btn-success w-100"
            type="button"
            (click)="reportConfirmationTemplate.close(true)"
            [disabled]="!selectedReportRecipientSet.size"
          >
            Send Report
          </button>
        </div>
      </div>
    } @else {
      <div class="mb-4 alert alert-danger">
        There are no recipients configured for this site
      </div>
      <div class="row mb-4">
        <div class="col">
          <button
            class="btn btn-lg btn-primary w-100"
            (click)="redirectToSite()"
          >
            Add Recipients (Site)
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg btn-outline-primary w-100"
            (click)="redirectToSite('client')"
          >
            Add Recipients (Client)
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>
<!-- edit corrective actions/ additonal notes  DIALOG -->
<ng-template
  #extraInfoTemplateRef
  let-extraInfoTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card m-0">
    <div class="card-header">
      {{ data?.extrainfoType == "ca" ? "Resolution" : "Incident Details" }}
      <span class="float-end" (click)="extraInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="form-group input-group my-2">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="1500"
          placeholder="Start typing"
          autofocus
          [(ngModel)]="newValue"
          id="updateextrainfoType"
        ></textarea>
        @if (newValue) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateextrainfoType')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            (click)="extraInfoTemplateRef.close(); newValue = ''"
            class="btn btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            (click)="updateExtraInfo(data); extraInfoTemplateRef.close()"
            class="btn btn-primary btn-lg w-100"
            [disabled]="previousTextValue === newValue"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #contactRecipientSelectionTemplate
  let-reportRecipientList="reportRecipientList"
>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3 mb-4">
    @if (reportRecipientList?.length > 1) {
      <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="
            selectedReportRecipientSet.size === reportRecipientList?.length
          "
          (change)="
            selectAllContactReportRecipients($event, reportRecipientList)
          "
          id="selectAllBox"
        />
        <label for="selectAllBox"
          >Select All [{{ reportRecipientList?.length }}]</label
        >
      </div>
    }
    @for (contact of reportRecipientList; track contact; let i = $index) {
      <div class="col form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="selectedReportRecipientSet.has(contact?.id)"
          (change)="selectUnselectRecipients(contact)"
          id="check-{{ contact?.id }}-{{ i }}"
        />
        <label class="form-check-label" for="check-{{ contact.id }}-{{ i }}">
          {{ contact?.user_full_name || contact?.full_name }}
          @if (contact?.is_site_contact) {
            <span class="small-font text-secondary">[Site Contact]</span>
          }
          <div class="small-font">
            {{ contact?.user_email || contact?.email }}
          </div>
        </label>
      </div>
    }
  </div>
</ng-template>
<!-- edit incident type  DIALOG -->
<ng-template
  #incidentTypeTemplateRef
  let-incidentTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Incident

      <span class="float-end" (click)="incidentTypeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <dt>Incident Type(s)</dt>
    <div class="d-flex flex-wrap gap-2 p-2">
      @for (
        incidentType of selectedIncidentTypeList;
        track incidentType;
        let i = $index;
        let l = $last
      ) {
        <div>
          <div>
            <div>
              @if (incidentType?.isFocused) {
                <ng-container>
                  <div class="mb-3">
                    <gtapp-auto-complete
                      [data]="incidentTypeList"
                      [maxLength]="256"
                      placeHolder="Search Incidents Type"
                      searchKeyword="name"
                      [initialValue]="previousincidentTypeValue"
                      [itemTemplate]="incidentTypeLookupTemplate"
                      [addInitialKey]="previousincidentTypeValue"
                      (inputChanged)="onSearchIncidentType($event)"
                      (selected)="onSelectIncidentType($event, i)"
                      inputId="iTypeLookupField"
                      [enableCloseOption]="true"
                      (fieldCleared)="openIncidentTypeLookup(i)"
                      (blurTriggered)="checkAndAddIncidentType(i)"
                    >
                    </gtapp-auto-complete>
                  </div>
                  <ng-template #incidentTypeLookupTemplate let-item>
                    @if (item?.key === 0) {
                      <div>Add Incident Type</div>
                    } @else {
                      <div>{{ item?.name }}</div>
                    }
                  </ng-template>
                </ng-container>
              } @else {
                <ng-container>
                  <div
                    class="d-flex gap-1 p-1 border rounded align-items-center"
                  >
                    {{ incidentType?.name }}
                    <span (click)="deleteSiteKeyField(i)">
                      <i class="fa-solid fa-circle-minus text-danger"></i>
                    </span>
                  </div>
                </ng-container>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (selectedIncidentTypeList.length < 10) {
      <div class="text-end my-2">
        <button
          (click)="addNewSiteKeyField()"
          class="btn btn-primary"
          [disabled]="
            selectedIncidentTypeList?.length
              ? !selectedIncidentTypeList[selectedIncidentTypeList?.length - 1]
                  ?.name
              : true
          "
        >
          Add Incident Type
        </button>
      </div>
    }

    <div>
      <div class="mb-3"></div>

      <ng-template #incidentTypeTemplate let-item>
        @if (item?.key === 0) {
          <div>Add New Incident Type</div>
        } @else {
          <div>{{ item?.name }}</div>
        }
      </ng-template>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            (click)="incidentTypeTemplateRef.close(); newValue = ''"
            class="btn btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            (click)="incidentTypeTemplateRef.close(); updateIncidentTypeList()"
            class="btn btn-primary btn-lg w-100"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- edit incident time  DIALOG -->
<ng-template
  #incidentTimeTemplateRef
  let-incidentTimeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update {{ data.name }} Time
      <span class="float-end" (click)="incidentTimeTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.minDateTime || data?.maxDateTime) {
      <div class="small border border-1 text-secondary p-2 mb-2 rounded-2">
        {{ data.name }} time must be
        @if (data?.minDateTime && data?.maxDateTime) {
          between {{ data?.minDateTime | customDate: "d MMM y HH:mm" }} &
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else if (data?.maxDateTime) {
          less than
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else {
          greater than {{ data?.minDateTime | customDate: "d MMM y HH:mm" }}
        }
      </div>
    }
    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="data.newValue"
        (change)="changeStatusTimeStamp($event, data)"
        [min]="data?.minDateTime"
        [max]="data?.maxDateTime"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="incidentTimeTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="incidentTimeTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #eventTimepStampUpdateTemplateRef
  let-eventTimepStampUpdateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update {{ data.name }} Time
      <span
        class="float-end"
        (click)="eventTimepStampUpdateTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.minDateTime || data?.maxDateTime) {
      <div class="small border border-1 text-secondary p-2 mb-2 rounded-2">
        {{ data.name }} time must be
        @if (data?.minDateTime && data?.maxDateTime) {
          between {{ data?.minDateTime | customDate: "d MMM y HH:mm" }} &
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else if (data?.maxDateTime) {
          less than
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else {
          greater than {{ data?.minDateTime | customDate: "d MMM y HH:mm" }}
        }
      </div>
    }
    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="data.newValue"
        (change)="changeStatusTimeStamp($event, data)"
        [min]="data?.minDateTime"
        [max]="data?.maxDateTime"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #reportDateTemplateRef
  let-reportDateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Report Date
      <span class="float-end" (click)="reportDateTemplateRef.close(false)">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-3">
      <input
        type="date"
        class="form-control"
        placeholder="Report Date"
        [(ngModel)]="data.newValue"
        (change)="changeStatusTimeStamp($event, data)"
        [min]="data?.minDateTime"
        [max]="data?.maxDateTime"
      />
      <label>Report Date</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="reportDateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="reportDateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
